import React, { FC, Fragment, useMemo } from 'react';

import { useRoutesWithBreadcrumbs } from '../../context';
import { Error404 } from '../ErrorPages';
import { AdCreate, AdEdit, Ads } from './pages';

export const AdsEntrypoint: FC = () => {
  const routesConfig = useMemo(() => [
    {
      label: 'Reklamy',
      element: <Ads />,
      path: '/',
    },
    {
      label: 'Nowa reklama',
      element: <AdCreate />,
      path: '/new',
    },
    {
      label: 'Edycja',
      element: <AdEdit />,
      path: '/:id/edit',
    },
    {
      path: '/*',
      element: <Error404 />,
    },
  ], []);

  const routes = useRoutesWithBreadcrumbs(routesConfig);

  return (
    <Fragment key="routes">{routes}</Fragment>
  );
};
